import React, { useState, useRef } from "react";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "./Audio.css";

function Audio({ e, index }) {
  const [showDescription, setShowDescription] = useState(false);
  const [duration, setDuration] = useState("00:00");
  const audioRef = useRef(null);

  const handleDuration = (e) => {
    if (e && e.target) {
      const minutes = Math.floor(e.target.duration / 60);
      const seconds = Math.floor(e.target.duration % 60);
      setDuration(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }
  };

  return (
    <div className="audio-player-card">
      <div className="audio-header">
        <h3 className="audio-title">{e.title}</h3>
        {e.description && (
          <button 
            className="description-toggle"
            onClick={() => setShowDescription(!showDescription)}
          >
            <i className={`fas fa-chevron-${showDescription ? 'up' : 'down'}`}></i>
            {showDescription ? 'Masquer les détails' : 'Afficher les détails'}
          </button>
        )}
      </div>

      {showDescription && (
        <div className="audio-description">
          <p>{e.description}</p>
        </div>
      )}

      <div className="audio-player-wrapper">
        <AudioPlayer
          ref={audioRef}
          src={e.URLAudio}
          showJumpControls={false}
          customProgressBarSection={[
            "PROGRESS_BAR",
            "CURRENT_TIME",
            "DURATION",
          ]}
          customControlsSection={[
            "MAIN_CONTROLS",
            "VOLUME_CONTROLS",
          ]}
          autoPlayAfterSrcChange={false}
          layout="horizontal"
          onLoadedMetadata={handleDuration}
          onCanPlay={handleDuration}
        />
      </div>

      <div className="audio-metadata">
        <span className="audio-date">
          <i className="far fa-calendar-alt"></i>
          {new Date(e.date || Date.now()).toLocaleDateString('fr-FR')}
        </span>
        <span className="audio-duration">
          <i className="far fa-clock"></i>
          {duration}
        </span>
        <span className="audio-size">
          <i className="fas fa-file-audio"></i>
          {e.size ? `${(e.size / 1024 / 1024).toFixed(2)} Mo` : 'Inconnu'}
        </span>
      </div>
    </div>
  );
}

export default Audio;
